import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Presentation from "./pages/Presentation";
import Reservation from "./pages/Reservation";
import References from "./pages/References";
import Contact from "./pages/Contact";
import NewsletterAdmin from "./pages/NewsletterAdmin";
import NewsletterTest from "./pages/NewsletterTest";
import ContactAdmin from "./pages/ContactAdmin";
import ContactTest from "./pages/ContactTest";
import DatabaseTest from "./pages/DatabaseTest";
import SiteAnalytics from "./pages/SiteAnalytics";
import AnalyticsTest from "./pages/AnalyticsTest";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/presentation" element={<Presentation />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/references" element={<References />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/newsletter-admin" element={<NewsletterAdmin />} />
          <Route path="/newsletter-test" element={<NewsletterTest />} />
          <Route path="/contact-admin" element={<ContactAdmin />} />
          <Route path="/contact-test" element={<ContactTest />} />
          <Route path="/database-test" element={<DatabaseTest />} />
          <Route path="/analytics" element={<SiteAnalytics />} />
          <Route path="/analytics-test" element={<AnalyticsTest />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
